module.exports = __webpack_public_path__ + "static/media/bulb.03a0773f.svg";